import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router";

const LoginPage = lazy(() => import("@/pages/sys/login"));
const AuthRedirectPage = lazy(() => import("@/pages/sys/login/auth-redirect"));

export const authRoutes: RouteObject[] = [
	{
		path: "login",
		element: (
			<Suspense fallback={<div>Loading...</div>}>
				<LoginPage />
			</Suspense>
		),
	},
	{
		path: "auth",
		element: (
			<Suspense fallback={<div>Loading...</div>}>
				<AuthRedirectPage />
			</Suspense>
		),
	},
];
